// two FB projects for DEV and PROD mode
const firebaseProject = process.env.REACT_APP_FIREBASE_PROJECT
const dev = firebaseProject === 'w4-salesbuddy-dev'

export const firebaseConfig = dev
  ? {
    apiKey: 'AIzaSyD-_gQAWr1l-9f4FpelD7-FqtruwYhy_Bc',
    authDomain: 'w4-salesbuddy-dev.firebaseapp.com',
    databaseURL: 'https://w4-salesbuddy-dev.firebaseio.com',
    projectId: 'w4-salesbuddy-dev',
    storageBucket: 'w4-salesbuddy-dev.appspot.com',
    messagingSenderId: '1014890354894'
  }
  : {
    apiKey: 'AIzaSyBIov6zYumqdh_Vz3aMwAoRTO_VGY5n_EQ',
    authDomain: 'w4-salesbuddy.firebaseapp.com',
    databaseURL: 'https://w4-salesbuddy.firebaseio.com',
    projectId: 'w4-salesbuddy',
    storageBucket: 'w4-salesbuddy.appspot.com',
    messagingSenderId: '194425212996'
  }



// WEBPACK FOOTER //
// ./src/firebase/config.js